import { hoursToMs, type NFTFormattedCollectibleDTO, queryClient } from '@capsicum/common';
import { type QueryKey, useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchMyCollectible } from '../api';

const myCollectiblesQueryKey: QueryKey = ['myCollectibles'];

export type UseMyCollectibleQueryOptions = Omit<
	UseQueryOptions<NFTFormattedCollectibleDTO, unknown, NFTFormattedCollectibleDTO | undefined>,
	'queryFn' | 'queryKey' | 'select'
>;

/**
 * @param collectibleId
 * @returns NFTFormattedCollectibleDTO
 */
export const useMyCollectibleQuery = <TData = NFTFormattedCollectibleDTO | undefined>(
	collectibleId: string,
	select?: (data: NFTFormattedCollectibleDTO | undefined) => TData,
	options?: UseMyCollectibleQueryOptions
) =>
	useQuery({
		initialData: () => queryClient?.getQueryData<NFTFormattedCollectibleDTO>(myCollectiblesQueryKey),
		initialDataUpdatedAt: () => (queryClient.getQueryState(myCollectiblesQueryKey)?.dataUpdatedAt || 0) * 1000, // convert unix timestamp to JS timestamp in milliseconds
		queryFn: () =>
			fetchMyCollectible({
				collectibleId
			}),
		queryKey: ['myCollectible', collectibleId],
		select,
		staleTime: hoursToMs(1),
		...options
	});
